"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=message-content.model.js.map